import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { RequestMethodEnum } from '@model';
import { CookieService } from './cookie.service';
import { GenericService } from './generic.service';

@Injectable()
export class LogoutService {
  API_ENDPOINT = '/api/v1/logout';

  constructor(
    private resourceService: GenericService,
  ) {}

  logout(): Observable<void> {
    const options = {
      method: RequestMethodEnum.DELETE,
      path: this.API_ENDPOINT,
    };
    const logout$ = this.resourceService.request<null, null>(options);
    logout$.pipe(tap(() => console.log(`Logout succeeded...`)));

    return logout$;
  }
}
